// ── 점수 관리 직원 목록 테이블 ────────────────────────────────────────────────
//   자동 항목(계약장수·잡은미팅·계약율)은 읽기 전용, 화합·기타만 인라인 입력.
//   금액·점수 입력은 type="number" 금지(스피너 화살표) → type="text" + inputMode.
//   2026-08-26 디자인 통일: 직원 관리 기준(designStandard) 표 토큰 사용.
import React from 'react';
import {
  stdTableWrap, stdTable, stdTh, stdCell, stdBadgeActive,
} from '../adminlayout/designStandard';

const fmtNum = (n) => (Number.isFinite(Number(n)) ? Number(n).toLocaleString('ko-KR') : '-');
const fmtScore = (n) => (Number.isFinite(Number(n)) ? String(Math.round(Number(n) * 10) / 10) : '-');

const th = stdTh;
const thR = { ...stdTh, textAlign: 'right' };

function autoCell(row, key, tdR) {
  const item = row.items.find((i) => i.key === key);
  if (!item) return <td style={tdR}>-</td>;
  const raw = key === 'contractRate'
    ? (item.rawValue === null ? '-' : `${fmtScore(item.rawValue)}%`)
    : `${fmtNum(item.rawValue)}${item.unit || ''}`;
  return (
    <td style={tdR}>
      <span style={{ color: 'var(--text-muted)' }}>{raw}</span>
      <span style={{ marginLeft: 6, fontWeight: 700, color: 'var(--text)' }}>{fmtScore(item.score)}</span>
      {item.note && <div style={{ fontSize: 10, color: '#dc2626' }}>{item.note}</div>}
    </td>
  );
}

export default function ScoreEmployeeTable({ rows, manualKeys, valueOf, isManualSet, patchDraft }) {
  const rowCount = rows.length;
  return (
    <div style={stdTableWrap}>
      <table style={{ ...stdTable, minWidth: 860 }}>
        <thead>
          <tr>
            <th style={th}>직원</th>
            <th style={th}>구분</th>
            <th style={thR}>계약장수 (점)</th>
            <th style={thR}>잡은미팅 (점)</th>
            <th style={thR}>계약율 (점)</th>
            {manualKeys.map((k) => (
              <th key={k.key} style={thR}>{k.label} (0~{k.maxPoints})</th>
            ))}
            <th style={thR}>총점</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => {
            const unset = !row.employmentType;
            const td = { ...stdCell(rowIndex, rowCount), whiteSpace: 'nowrap' };
            const tdR = { ...td, textAlign: 'right' };
            return (
              <tr key={row.userId}>
                <td style={{ ...td, fontWeight: 700 }}>
                  {row.name}
                  {row.resignDate && <span style={{ marginLeft: 6, fontSize: 10, color: '#dc2626' }}>퇴사 {row.resignDate}</span>}
                </td>
                <td style={td}>
                  {unset ? (
                    <span style={{ color: '#dc2626', fontWeight: 700 }} title="근무유형 이력이 없어 풀타임/파트타임을 판정할 수 없습니다.">
                      미설정 ⚠
                    </span>
                  ) : (
                    <span style={{ ...stdBadgeActive, fontSize: 11 }}>
                      {row.employmentType === 'fulltime' ? '풀타임' : '파트타임'}
                      <span style={{ marginLeft: 4, color: 'var(--text-muted)', fontWeight: 500 }}>주{row.weeklyHours}h</span>
                    </span>
                  )}
                </td>
                {autoCell(row, 'tickets', tdR)}
                {autoCell(row, 'meetings', tdR)}
                {autoCell(row, 'contractRate', tdR)}
                {manualKeys.map((k) => {
                  const value = valueOf(row, k.key);
                  const num = Number(value);
                  const invalid = String(value).trim() !== '' && (!Number.isFinite(num) || num < Number(k.minPoints || 0) || num > Number(k.maxPoints));
                  const edited = isManualSet(row, k.key);
                  return (
                    <td key={k.key} style={tdR}>
                      <input
                        type="text"
                        inputMode="decimal"
                        maxLength={5}
                        value={value}
                        onChange={(e) => patchDraft(row.userId, k.key, e.target.value)}
                        placeholder={String(k.defaultPoints)}
                        style={{
                          width: 62, textAlign: 'right', padding: '5px 7px', borderRadius: 6,
                          border: `1px solid ${invalid ? '#dc2626' : 'var(--border)'}`,
                          background: 'var(--bg-card)',
                          color: edited ? 'var(--text)' : 'var(--text-muted)',
                          fontWeight: edited ? 800 : 500,
                        }}
                      />
                    </td>
                  );
                })}
                <td style={{ ...tdR, fontWeight: 900, color: unset ? 'var(--text-muted)' : 'var(--text)' }}>
                  {fmtScore(row.totalScore)}
                </td>
              </tr>
            );
          })}
          {rows.length === 0 && (
            <tr>
              <td style={{ ...stdCell(0, 1), textAlign: 'center', color: 'var(--text-muted)' }} colSpan={6 + manualKeys.length}>
                대상 직원이 없습니다.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
